
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { ItsrApiService } from './itsr-api.service';
import { SessionStorageService } from './sessionstorage.service';
import { SessionTimeoutService } from './session-timeout.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

    constructor(private itsrApiService:ItsrApiService,
                private sessionState: SessionStorageService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
            const loginSession = this.sessionState.getAuthData();
            if(loginSession != null && error.status === 401) {
                let body = JSON.stringify(loginSession.refresh_token);
                return this.itsrApiService.post(ItsrApiService.UrlRefreshToken,body).pipe(
                    switchMap((res: any)=>{
                        if(!!res.body){
                            this.sessionState.setAuthData(res.body);
                        }
                        const newLoginSession = this.sessionState.getAuthData();
                        return next.handle(request.clone({
                            setHeaders:{
                                'Authorization': 'Bearer ' + newLoginSession.access_token
                            }
                        }))
                    })
                )
            }
            else {
                throw error;
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/RefrshTokenInterceptor.ts